<template>
  <div class="cs-video-intro" ref="csIntro">
    <div class="cs-intro">
      <div class="cs-intro--text-block">
        <Heading
          v-if="name"
          type="h1"
          className="cs-intro--text-drop"
          :text="name"
        ></Heading>
        <Heading v-if="heading" type="h1" :text="heading"></Heading>
        <p v-if="excerpt">
          {{ excerpt }}
        </p>
      </div>
      <div class="cs-video-wrapper">
        <video
          v-if="video"
          class="cs-video"
          autoplay
          disablePictureInPicture
          playsinline
          loop
          muted
          preload="metadata"
          disableremoteplayback
          :poster="posterImage"
        >
          <source :src="video.src" :type="video.videoType" />
        </video>
        <div class="cs-video-wrapper-outline"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Heading from "@/components/Heading";
import { useTransitionComposable } from "../../composables/transition-composable";
import { ref, watch, onUnmounted } from "vue";
import { gsap } from "gsap";

const { transitionState } = useTransitionComposable();

export default {
  name: "CsVideoIntro",
  components: {
    Heading,
  },
  data() {
    return {
      inView: false,
    };
  },
  props: {
    heading: {
      type: String,
    },
    name: {
      type: String,
    },
    excerpt: {
      type: String,
    },
    video: {
      type: Object,
      src: String,
      videoType: String,
    },
    posterImage: {
      type: String,
    },
  },
  setup() {
    const csIntro = ref(null);
    const viewable = ref(false);
    const ctx = ref();
    watch(
      [() => transitionState.transitionComplete, csIntro],
      (newValue) => {
        if (newValue[0] == true && csIntro.value) {
          const el = csIntro.value;
          let mm = gsap.matchMedia();
          mm.add(`(min-width: 768px)`, () => {
            ctx.value = gsap.timeline({
              scrollTrigger: {
                trigger: el,
                start: "0% 0%", // when the top of the trigger hits the top of the viewport
                end: "50%",
                scrub: 1,
              },
            });

            ctx.value.to(el.querySelector(".cs-video-wrapper video"), {
              // maxWidth: "428px",
              // height: "428px",
              opacity: 1,
              duration: 2,
              // y: 60,
              top: "0%",
              left: "0%",
              // x: -5
            });
            ctx.value.to(
              el.querySelector(".cs-video-wrapper-outline"),
              {
                top: "0%",
                //   y: -60,
                left: "0%",
                //   duration: 2,
              },
              "-=2",
            );
            ctx.value.to(
              el.querySelector(".cs-intro--text-block h1"),
              {
                //   opacity: 0,
                y: 100,
                duration: 2,
              },
              "-=1.85",
            );
            ctx.value.to(
              el.querySelector(".cs-intro--text-block p"),
              {
                //   opacity: 0,
                y: 100,
                duration: 2,
              },
              "-=2",
            );
            //   ctx.value.to(el.querySelector(".cs-video-wrapper"), {
            //     opacity: 0,
            //     duration: 1,
            //     // x: -5
            //   });
          });
        }
      },
      {
        immediate: true,
      },
    );
    onUnmounted(() => {
      ctx.value.revert(); // <- Easy Cleanup!
    });
    return { csIntro, viewable }; // WILL NOT WORK WITHOUT THIS
  },
};
</script>
